import { API_IDS } from '@intigral/constant';
import { DI } from '@intigral/constant/config/DIContainer';
import { IReminderRepository } from '../../core/repositories/interfaces/iReminderRepository';
import { container } from '../../DataDomain';
import { IHttpAdapter } from '../../entity/interface/iHttpAdapter';
import {
    IReminderListParams,
    IReminderListResponse,
    IReminderResponse,
    IReminderSetRequest,
    IReminderSetResponse,
    IReminderUnSetRequest,
} from '../../entity/interface/iReminder';
import { IApiPathManager } from '../config/ApiPathManager';

class ReminderRepository implements IReminderRepository {
    // Lazy getters for dependencies to avoid circular dependencies
    private get http(): IHttpAdapter {
        return container.resolve<IHttpAdapter>(DI.UTILS.IHttpAdapter);
    }

    private get apiPathManager(): IApiPathManager {
        return container.resolve<IApiPathManager>(DI.UTILS.IApiPathManager);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async setReminder(
        apiKey: string,
        payload: IReminderSetRequest,
        token: string,
        identityToken: string,
        lang: string,
        type: string
    ): Promise<IReminderSetResponse> {
        const response = await this.http.post<IReminderSetResponse>(
            this.apiPathManager.getPath(API_IDS.REMINDER_API_SET_REMINDER),
            {
                params: {
                    apikey: apiKey,
                    category: type,
                },
                headers: {
                    Authorization: token,
                    identityToken: identityToken,
                    'Accept-Language': lang,
                },
                body: payload,
            }
        );
        return response.data;
    }

    async unSetReminder(
        apiKey: string,
        payload: IReminderUnSetRequest,
        token: string,
        identityToken: string
    ): Promise<IReminderResponse> {
        const response = await this.http.put<IReminderResponse>(
            this.apiPathManager.getPath(API_IDS.REMINDER_API_UNSET_REMINDER),
            {
                params: {
                    apikey: apiKey,
                },
                headers: {
                    Authorization: token,
                    identityToken: identityToken,
                },
                body: payload,
            }
        );
        return response.data;
    }

    async listReminder(
        apiKey: string,
        searchParams: IReminderListParams,
        token: string,
        identityToken: string
    ): Promise<IReminderListResponse> {
        const path = this.apiPathManager.getPath(API_IDS.REMINDER_LIST);
        const response = await this.http.get<IReminderListResponse>(path, {
            params: {
                apikey: apiKey,
                ...searchParams,
            },
            headers: {
                Authorization: token,
                identityToken: identityToken,
            },
        });
        return response.data;
    }
}

export default ReminderRepository;
